type AccountFontsData = { url: string }[];

type CustomFontsData = {
  font_settings: AccountFontsData[];
};

export type WidgetFontsData = {
  [key: string]: AccountFontsData[] | CustomFontsData;
};

export const loadWidgetFonts = (list: WidgetFontsData | undefined) => {
  if (!list) return;

  const isArray = Array.isArray(list);
  if (!list || (isArray && !list.length)) return;

  const fontsArray = isArray ? list : Object.values(list);
  fontsArray.forEach((font) => {
    // If font has property of font_settings, loop through font_settings array
    if (font.font_settings) {
      return loadWidgetFonts(font.font_settings);
    }

    const isFontLoaded = document.querySelector(`link[href="${font.url}"]`);
    if (!font.url || isFontLoaded) return;

    const fontLink = document.createElement('link');
    document.head.appendChild(fontLink);
    fontLink.rel = 'stylesheet';
    fontLink.href = font.url;
  });
};
